var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-common"},[_c('img',{staticClass:"img",attrs:{"src":require("@/assets/images/mobile-empty.png")}}),_c('p',[_vm._v("会员管理项目暂未提供移动版本")]),_c('p',[_vm._v("请前往电脑")]),_c('a',{staticClass:"btn",attrs:{"href":"/organization/index"}},[_vm._v("知道了")])])
}]

export { render, staticRenderFns }